"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _objectFitImages = _interopRequireDefault(require("object-fit-images"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _getIndustriesWithOrganisationInfo = _interopRequireDefault(require("../utils/getIndustriesWithOrganisationInfo"));

var _buildBasicProfilePayload = _interopRequireDefault(require("../utils/buildBasicProfilePayload"));

var _getOrganisationSuggestions = _interopRequireDefault(require("../utils/getOrganisationSuggestions"));

var _utils = require("../../../utils");

var _EditOrganisationStage = _interopRequireDefault(require("../../EditOrganisationStage"));

var _BasicProfileForm = _interopRequireDefault(require("./BasicProfileForm"));

require("../styles/_basic-profile.scss");

var _getDefaultAlias = _interopRequireDefault(require("../utils/getDefaultAlias"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RESERVED_SEGMENTS = ['develop', 'staging', 'app'];

var BasicProfile = /*#__PURE__*/function (_Component) {
  _inherits(BasicProfile, _Component);

  function BasicProfile(props) {
    var _this;

    _classCallCheck(this, BasicProfile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BasicProfile).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getIndustries", (0, _memoizeOne.default)(function (organisations) {
      return (0, _getIndustriesWithOrganisationInfo.default)(organisations, 'organisation-basic-profile__industry-suffix');
    }));

    _defineProperty(_assertThisInitialized(_this), "getOrganisations", (0, _memoizeOne.default)(_getOrganisationSuggestions.default));

    _defineProperty(_assertThisInitialized(_this), "updateInputField", (0, _lodash.default)(function (fieldName) {
      return function (result) {
        _this.setState(_defineProperty({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "organisationAlreadyExists", function (field, value, organisations) {
      var currentOrganisation = _this.props.organisation;

      var _ref = currentOrganisation || {},
          organisationId = _ref.organisationId;

      if (!organisations) return false;
      return Boolean(organisations.find(function (organisation) {
        if (!organisation[field]) return false;
        return organisation[field].toLowerCase() === value.toLowerCase() && organisation.organisationId !== organisationId;
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "isValidOrganisationField", function (field) {
      return function (value) {
        var organisations = _this.props.organisations;
        return !_this.organisationAlreadyExists(field, value, organisations);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateAliasField", function (result) {
      var value = (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result);

      _this.setState({
        alias: (0, _getDefaultAlias.default)(value),
        aliasChanged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateLocation", function (location, _ref2) {
      var isValidAddress = _ref2.isValidAddress;

      _this.setState({
        location: location,
        isValidAddress: isValidAddress
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaveImage", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var organisationId, apolloClient, imageFile, profileImageKey, _ref5, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                organisationId = _ref3.organisationId;
                apolloClient = _this.props.apolloClient;
                imageFile = _this.state.imageFile;

                if (imageFile) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                profileImageKey = (0, _utils.buildBucketKey)('organisation', organisationId, 'profileimage');
                _context.next = 8;
                return (0, _utils.saveOptionalFile)({
                  apiClient: apolloClient,
                  key: profileImageKey,
                  file: imageFile,
                  organisationId: organisationId
                });

              case 8:
                _ref5 = _context.sent;
                error = _ref5.error;

                if (!error) {
                  _context.next = 12;
                  break;
                }

                throw new Error(error);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "saveExistingOrganisation", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref6) {
        var input, organisationId, imageFile, _this$props, updateOrganisation, goToNextWizardStage, profileImageKey, inputWithImageKey, _ref8, data, error;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                input = _ref6.input, organisationId = _ref6.organisationId;
                imageFile = _this.state.imageFile;
                _this$props = _this.props, updateOrganisation = _this$props.updateOrganisation, goToNextWizardStage = _this$props.goToNextWizardStage;
                profileImageKey = (0, _utils.buildBucketKey)('organisation', organisationId, 'profileimage');
                inputWithImageKey = imageFile ? _objectSpread({}, input, {
                  imageUrl: profileImageKey
                }) : input;
                _context2.next = 7;
                return updateOrganisation({
                  input: inputWithImageKey,
                  afterware: _this.handleSaveImage
                });

              case 7:
                _ref8 = _context2.sent;
                data = _ref8.data;
                error = _ref8.error;

                if (!(error || !data)) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", void _this.setState({
                  saving: false
                }));

              case 12:
                goToNextWizardStage();

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref7.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "saveNewOrganisation", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref9) {
        var input, imageFile, _this$props2, updateOrganisation, goToNextWizardStage, _ref11, data, error, organisationId, profileImageKey, _ref12, imageUrlError;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                input = _ref9.input;
                imageFile = _this.state.imageFile;
                _this$props2 = _this.props, updateOrganisation = _this$props2.updateOrganisation, goToNextWizardStage = _this$props2.goToNextWizardStage;
                _context3.next = 5;
                return updateOrganisation({
                  input: input,
                  afterware: _this.handleSaveImage
                });

              case 5:
                _ref11 = _context3.sent;
                data = _ref11.data;
                error = _ref11.error;

                if (!(error || !data)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", void _this.setState({
                  saving: false
                }));

              case 10:
                if (imageFile) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", void goToNextWizardStage());

              case 12:
                // We have to update the organisation with the bucket key because we had to wait for the createOrganisation
                // request to respond with the new organisationId
                organisationId = data.createOrganisation.organisationId;
                profileImageKey = (0, _utils.buildBucketKey)('organisation', organisationId, 'profileimage');
                _context3.next = 16;
                return updateOrganisation({
                  input: {
                    imageUrl: profileImageKey
                  }
                });

              case 16:
                _ref12 = _context3.sent;
                imageUrlError = _ref12.error;

                if (!imageUrlError) {
                  _context3.next = 20;
                  break;
                }

                return _context3.abrupt("return", void _this.setState({
                  saving: false
                }));

              case 20:
                goToNextWizardStage();

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref10.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleSaveOrganisation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$props3, organisation, organisations, hasUpdatePermission, goToNextWizardStage, input;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props3 = _this.props, organisation = _this$props3.organisation, organisations = _this$props3.organisations, hasUpdatePermission = _this$props3.hasUpdatePermission, goToNextWizardStage = _this$props3.goToNextWizardStage;

              if (hasUpdatePermission) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return", goToNextWizardStage());

            case 3:
              input = (0, _buildBasicProfilePayload.default)(organisation, _objectSpread({}, _this.state, {
                alias: _this.getAliasValue()
              }), organisations);

              _this.setState({
                saving: true
              });

              if (!(organisation && organisation.organisationId)) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", _this.saveExistingOrganisation({
                input: input,
                organisationId: organisation.organisationId
              }));

            case 7:
              return _context4.abrupt("return", _this.saveNewOrganisation({
                input: input
              }));

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleSelectImage", function (files) {
      var _files$slice = files.slice(-1),
          _files$slice2 = _slicedToArray(_files$slice, 1),
          file = _files$slice2[0];

      _this.setState({
        imageUrl: URL.createObjectURL(file),
        imageFile: file
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAliasValue", function () {
      var _this$state = _this.state,
          alias = _this$state.alias,
          name = _this$state.name,
          aliasChanged = _this$state.aliasChanged;
      return alias || (aliasChanged ? alias : name && (0, _getDefaultAlias.default)(name));
    });

    _defineProperty(_assertThisInitialized(_this), "isAliasTaken", function () {
      var organisations = _this.props.organisations;

      var displayedAlias = _this.getAliasValue();

      return !_this.organisationAlreadyExists('alias', displayedAlias, organisations) && !RESERVED_SEGMENTS.includes(displayedAlias);
    });

    _defineProperty(_assertThisInitialized(_this), "isValidOrganisationProfile", function () {
      var _this$state2 = _this.state,
          name = _this$state2.name,
          industry = _this$state2.industry,
          contentRegion = _this$state2.contentRegion,
          isValidAddress = _this$state2.isValidAddress;
      var _this$props4 = _this.props,
          organisations = _this$props4.organisations,
          organisation = _this$props4.organisation;
      return Boolean(name && industry && contentRegion && isValidAddress && _this.getAliasValue() && _this.isAliasTaken() && (organisation && organisation.organisationId || !_this.organisationAlreadyExists('name', name, organisations)));
    });

    var _organisation = props.organisation || {};

    _this.state = {
      name: _organisation.name || '',
      alias: _organisation.alias || '',
      imageUrl: _organisation.imageUrl,
      imageFile: void 0,
      parentOrganisation: (0, _lodash2.default)(_organisation, 'parentOrganisation.name', ''),
      industry: _organisation.industry || '',
      contentRegion: _organisation.contentRegion,
      location: _organisation.location || {},
      notes: _organisation.notes || '',
      socialProfiles: _organisation.socialProfiles || {},
      isValidAddress: Boolean(_organisation.organisationId),
      saving: false,
      aliasChanged: false
    };
    return _this;
  }

  _createClass(BasicProfile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _objectFitImages.default)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          organisation = _this$props5.organisation,
          organisations = _this$props5.organisations,
          hasUpdatePermission = _this$props5.hasUpdatePermission;
      return _react.default.createElement(_EditOrganisationStage.default, {
        title: "".concat(!organisation ? 'New' : 'Modify', " Client Account")
      }, _react.default.createElement("div", {
        className: "organisation-basic-profile"
      }, _react.default.createElement(_BasicProfileForm.default, _extends({}, this.state, {
        alias: this.getAliasValue(),
        industries: this.getIndustries(organisations),
        validForm: this.isValidOrganisationProfile(),
        organisations: this.getOrganisations(organisations),
        onSelectImage: this.handleSelectImage,
        updateInputField: this.updateInputField,
        updateAliasField: this.updateAliasField,
        updateLocation: this.updateLocation,
        onSave: this.handleSaveOrganisation,
        isValidOrganisationField: this.isValidOrganisationField,
        isAliasTaken: this.isAliasTaken(),
        hasUpdatePermission: hasUpdatePermission
      }))));
    }
  }]);

  return BasicProfile;
}(_react.Component);

exports.default = BasicProfile;

_defineProperty(BasicProfile, "defaultProps", {
  organisations: []
});